// Multiply by 2 to acommodate high-density/retina displays
export enum AssetCommonMaxWidth {
    Nft = 500,
}
